import { Banner, AlertIcon, Typography } from '@iheartjane/reefer';

export const ExpirationScreen = () => {
  return (
    <>
      <Typography variant="h1-semibold">Error</Typography>
      <Banner
        full
        mt={12}
        icon={<AlertIcon />}
        variant="error"
        label="Payment link has expired"
      />
      <Typography mt={12}>
        Your order has been fulfilled and is out for delivery. Please pay the
        driver when they arrive.
      </Typography>
    </>
  );
};
